module.exports = __webpack_public_path__ + "c7d3d9671c5c0cdff1b263d52b6902a0.svg";